export const facebookLink = 'https://www.facebook.com/events/974547811288491/';
export const aftermovies = {
  2023: 'https://www.youtube.com/watch?v=qgqrFQ-c-u0',
  2022: 'https://www.youtube.com/watch?v=tXlOXChLas0',
  2021: 'https://www.youtube.com/watch?v=TBUkNU9rd_A',
  2019: 'https://www.youtube.com/watch?v=5u-E5_j5bP4',
  2018: 'https://www.youtube.com/watch?v=2glC9tESeQc',
  2017: 'https://www.youtube.com/watch?v=W8Kvepxrfuw',
  2016: 'https://www.youtube.com/watch?v=TBvnlTET4V4',
  2015: 'https://www.youtube.com/watch?v=SNr9VES6ZXQ',
};
